export const ColorNameToHexMapper = {
  green: 'bg-[#8FAA6D]',
  gray: 'bg-[#BFBFBF]',
  beige: 'bg-[#E0DCC7]',
  white: 'bg-[#FFFFFF] outline outline-offset-1 outline-gray-100',
  blue: 'bg-[#6786BA]',
  brown: 'bg-[#A37A57]',
  yellow: 'bg-[#F2E07F]',
  purple: 'bg-[#B38BC9]',
  orange: 'bg-[#E6A85F]',
  pink: 'bg-[#F0BCCE]',
  red: 'bg-[#DD6363]',
  black: 'bg-[#2F2F2F]',
  turquoise: 'bg-[#A7D8DE]',
  blackwhite: 'bg-dual-pattern outline outline-offset-1 outline-gray-100',
  multi:
    'bg-multi-pattern bg-no-repeat bg-[length:100%_50%] bg-multi-position',
};
